export enum License {
  Any = "Any",
  AccuracyEarlyAdopter = "AccuracyEarlyAdopter",
  AccuracyStandard = "AccuracyStandard",
  AdequacyEarlyAdopter = "AdequacyEarlyAdopter",
  AdequacyStandard = "AdequacyStandard",
}
